// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"LoadingPlaceholder_placeholder__1uSa4","rectangle":"LoadingPlaceholder_rectangle__2txuk","circle":"LoadingPlaceholder_circle__3-_jM"};